



















helpers = require('../../helpers.coffee')

view_model = {
  components:
    contactsPickerTextCsv: require './picker/text_csv'

  data: ->
    new_contacts: {}

  methods:
    contactsEmpty: ->
      jQuery.isEmptyObject(@contacts)

    selectContacts: ->
      EventsBus.$emit 'contacts-picker-text-csv-validate'

    contactsAdded: (data) ->
      @new_contacts = data.contacts
      EventsBus.$emit 'contact-picker-contacts-added', { contacts: @new_contacts }
      jQuery('#contacts-manual-picker').modal 'hide'

  created: ->
    EventsBus.$on 'contacts-picker-text-csv-publish', @contactsAdded

  beforeDestroy: ->
    EventsBus.$off 'contacts-picker-text-csv-publish', @contactsAdded

}

exports.default = helpers.vue_include(view_model, helpers.form, helpers.contacts.list_view_modes)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/contacts/manual_picker.vue